import * as React from "react";
import {IReadSubOrganizationResponse} from "../../../core/api/organization/response/ReadSubOrganizationResponse";

interface IProps {
    organizationSlug: string;
    data: IReadSubOrganizationResponse;
}

interface IState {
    menuItem: {}
}

export class SubOrganizationItem extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            menuItem: {}
        }
    }

    public render() {
        return (
            <div className="blog-item">
                <h4 className="font-alt">
                    <a href={'/dusun/'+this.props.organizationSlug+'/organisasi/' + this.props.data.slug}>{this.props.data.name}</a>
                </h4>
                <div className="blog-item-data">
                    <a href={'/dusun/'+this.props.organizationSlug+'/organisasi/' + this.props.data.slug}><i className="fa fa-user" /> {this.props.data.leader}</a>
                </div>
                <hr />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/village-organization/sub-organization/SubOrganizationItem.tsx